webpackJsonp([1],{

/***/ "1xcZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "88GH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BL8g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BNiI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C3XE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7007daf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("C3XE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25a07e32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("1xcZ")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-212a0afc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("loeG")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-212a0afc"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f0bb17a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("BL8g")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-9f0bb17a"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6f8c210","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}),0)]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("tATK")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-b6f8c210"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e63bb88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("mLy2")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3233e303","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}),0)])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("n9S7")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ab0e8b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}),0)])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("y5zj")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3738d1d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){return _vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("lGnO")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 30,
        height: 30
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eaf2795","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("URg0")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f2bd431","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("d/CA")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a2707b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){return _vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){return _vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()}),0):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("88GH")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60a0c009","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}),1):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}),1)])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("oEyU")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f17fad4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){return _vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])}),0),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("icNF")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0693ed8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return null}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28207f05","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}),0)}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("gck0")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6778dfcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("BNiI")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9ef5fee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}),0)],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("gqD2")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-c9ef5fee"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-413a4779","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("yREt")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fff93bc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("tki5")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-658cd5a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("ye3r")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "The Loop - The European Beverage Can Magazine - Issue 1",
  "shortTitle": "",
  "description": "",
  "width": 1227,
  "height": 868,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "#"
  }],
  "basePath": "/issue1",
  // "basePath": "",
  "companyLogo": "1-logo-1.png",
  "publishURL": "http://touchline-loop.s3-website.eu-west-2.amazonaws.com/issue1/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 1-logo\" style=\"top: -97px;left: -174px;\" src=\"/issue1/static/_content/1-logo-1.png\" />\n        <img class=\"abs halfScale 1-title\" style=\"top: 356px;left: 61px;\" src=\"/issue1/static/_content/1-title-1.png\" />\n        <img class=\"abs halfScale 1-sub\" style=\"top: 550px;left: 66px;\" src=\"/issue1/static/_content/1-sub-1.png\" />\n        <img class=\"abs halfScale 1-sub\" style=\"top: 660px;left: 124px;\" src=\"/issue1/static/_content/1-sub-2.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-logo\"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"1-title\"), 0.6, {y:30,opacity:0}, {y:0, opacity:1, ease: Power2.easeNone}, 0.3, 1.3)\n          .staggerFromTo(cOf(\"1-sub\"), 0.6, {x:30,opacity:0}, {x:0, opacity:1, ease: Power2.easeNone}, 0.3, 1.6)\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "The European Beverage Can Magazine  COLLECTION IS KEY The three essential ingredients to building a strong, circular beverage can economy  The highlights of the Canettes d'Or Awards  The latest can innovation and design developments"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 2-title\" style=\"top:94px;left:129px\" src=\"/issue1/static/_content/2-title-1.png\" />\n\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(3);\" \n          style=\"top:171px; left:129px; width:207px; height:19px;\"></div>\n\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(4);\" \n          style=\"top:204px; left:141px; width:335px; height:474px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(9);\" \n          style=\"top:204px; left:492px; width:335px; height:474px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(15);\" \n          style=\"top:204px; left:846px; width:335px; height:474px;\"></div>\n\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(4);\" \n          style=\"top:695px; left:169px; width:207px; height:19px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(8);\" \n          style=\"top:731px; left:169px; width:207px; height:19px;\"></div>\n\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(9);\" \n          style=\"top:695px; left:523px; width:207px; height:19px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(14);\" \n          style=\"top:731px; left:523px; width:207px; height:39px;\"></div>\n\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(15);\" \n          style=\"top:695px; left:876px; width:216px; height:19px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(18);\" \n          style=\"top:731px; left:876px; width:216px; height:19px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(22);\" \n          style=\"top:784px; left:856px; width:286px; height:23px;\"></div>\n\n        <div id=\"subscribe-overlay\" class=\"standardTransition contentOverlay hidden noclick\">\n          <div id=\"mc_embed_shell\">\n            <link href=\"//cdn-images.mailchimp.com/embedcode/classic-061523.css\" rel=\"stylesheet\" type=\"text/css\">\n            <div id=\"mc_embed_signup\">\n              <img id=\"subscription-cross\" onclick=\"hideOverlay('subscribe-overlay')\" src=\"/issue1/static/_content/subscription-cross.png\" />\n              <form action=\"https://kpstudio.us22.list-manage.com/subscribe/post-json?u=1db79021f22160aa6c8eff4de&amp;id=41edb2fc75&amp;f_id=0030c1e1f0&c=?\" method=\"post\" id=\"mc-embedded-subscribe-form\" name=\"mc-embedded-subscribe-form\" class=\"validate\" target=\"_blank\">\n                <div id=\"mc_embed_signup_scroll\">\n                  <img id=\"subscription-img\" src=\"/issue1/static/_content/subscription-img.png\" />\n                  <h2 class=\"sommet-rounded\">Stay in the loop!</h2>\n                  <div class=\"mc-field-group\">\n                    <label class=\"open-sans-regular\" for=\"mce-EMAIL\">\n                      Enter your email below to receive future issues of <strong class=\"open-sans-bold\">The Loop</strong> direct to your inbox\n                    </label>\n                    <input type=\"email\" name=\"EMAIL\" class=\"required email open-sans-regular\" id=\"mce-EMAIL\" required=\"\" value=\"\" placeholder=\"johnsmith@email.com\">\n                  </div>\n                  <div id=\"mce-responses\" class=\"clear\">\n                    <div class=\"response open-sans-regular\" id=\"mce-error-response\" style=\"display: none;\"></div>\n                    <div class=\"response open-sans-regular\" id=\"mce-success-response\" style=\"display: none;\">There has been an error, please try again.</div>\n                  </div>\n                  <div aria-hidden=\"true\" style=\"position: absolute; left: -5000px;\"><input type=\"text\" name=\"b_1db79021f22160aa6c8eff4de_41edb2fc75\" tabindex=\"-1\" value=\"\"></div>\n                  <div class=\"clear\"><input type=\"submit\" name=\"subscribe\" id=\"mc-embedded-subscribe\" class=\"button sommet-rounded\" value=\"Subscribe\" onclick=\"mailChimpSubmit()\"></div>\n                </div>\n              </form>\n            </div>\n            <script type=\"text/javascript\" src=\"//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js\"></script>\n            <script type=\"text/javascript\">(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';fnames[5]='BIRTHDAY';ftypes[5]='birthday';}(jQuery));var $mcj = jQuery.noConflict(true);</script>\n          </div>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax();\n          pg2Anim.staggerFromTo(cOf(\"2-title\"), 0.5, {opacity:0, x:40}, {opacity:1, x:0, onComplete: addContentLinks}, 0.2, 1)\n          \n          setTimeout(function(){\n            showOverlay('subscribe-overlay');\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop();\n          removeContentLinks();\n          \n          hideOverlay('subscribe-overlay');\n      }\n      ",
    "searchText": "the loop  CONTENTS 03  Opening statement  Contents  09  23  Collection is key		  08  The road to 100%		  09  Industry innovation  14  The 2023 Canettes d’Or awards  ustry Ind  inabili sta  Su  02  04  I  ty  16 ovation nn  04  22  16  Market overview		  18  The pursuit of net zero		 About Metal Packaging Europe"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 3-title\" style=\"top:97px;left:140px\" src=\"/issue1/static/_content/3-title-1.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg3Anim = new TimelineMax();\n          pg3Anim.staggerFromTo(cOf(\"3-title\"), 0.5, {opacity:0, x:40}, {opacity:1, x:0, onComplete: addContentLinks}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg3Anim.stop();\n          removeContentLinks();\n      }\n      ",
    "searchText": "Introduction  the loop  03 23  OPENING STATEMENT  to collaborating with MPE members  regulatory developments, offering  on positioning rigid metal packaging –  expert analysis and inspiring design  including the invaluable beverage can  examples. The following pages also  – as a circularity champion and the  include the highlights of the Canettes  perfect partner for a sustainable future.  d'Or awards ceremony in Paris and a deep dive into the current state  MPE’s collaboration with valued partners  of can recycling.  As Metal Packaging Europe’s new CEO,  across the metal packaging value chain,  I’m pleased to present the first issue of  including European Aluminium, Alupro  Thank you for reading The Loop  our new beverage can magazine, The Loop,  and Every Can Counts, is integral to  and for joining us on the beverage  which celebrates the circularity, creative  our joint work in pursuit of circularity.  can journey!  potential and infinite versatility of the  We thank these partners for their  beverage can.  contributions to our magazine.  This is my first opportunity to greet many  In this first edition, The Loop will cover  of you and share my excitement about  the beverage can industry’s sustainability,  our journey together. I’m looking forward  creativity, innovation and related  Best wishes,  Krassimira Kazashka CEO, Metal Packaging Europe"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 4-title-1\" style=\"top:90px;left:144px\" src=\"/issue1/static/_content/4-title-1.png\" />\n      <img class=\"halfScale 4-title-2\" style=\"top:189px;left:146px\" src=\"/issue1/static/_content/4-title-2.png\" />\n      <img class=\"halfScale 4-sub\" style=\"top:310px;left:146px\" src=\"/issue1/static/_content/4-sub-1.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.fromTo(cOf(\"4-title-1\"), 0.5, {opacity:0, x:30}, {opacity:1, x:0, onComplete: addContentLinks}, 1)\n          .fromTo(cOf(\"4-title-2\"), 0.5, {opacity:0, y:30}, {opacity:1, y:0, onComplete: addContentLinks}, 1.3)\n          .fromTo(cOf(\"4-sub\"), 0.5, {opacity:0, y:30}, {opacity:1, y:3, onComplete: addContentLinks}, 1.6)\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n      }\n      ",
    "searchText": "the loop  inabili sta  ty  Su  Section 1  COLLECTION IS KEY SPREADING THE MESSAGE THAT EVERY CAN COUNTS  F  igures recently released by  Metal Packaging Europe and European Aluminium show that 76% of beverage cans were recycled in Europe in 2021. A 3% increase on the previous year means the industry is making steady progress towards its 2030 target of 100% recycling. This impressive figure also matches the heights of a record-breaking 2018, but with one crucial difference – millions more  There are three essential ingredients – infrastructure, legislation and consumer engagement – to building a strong circular beverage can economy.  04 23  Written by Lynda Searby  cans are now being used and recycled than ever before. However, it is the story behind the figures that makes for the most interesting reading."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScaleC halfpulsetwo animatedpulse z-index-set\" src=\"/issue1/static/_content/5-img-1.png\" style=\"top:591px;left:353px;\" />\n      \n      <div class=\"abs contentLinkNone\" style=\"top:659px;left:420px;width:185px;height: 185px;\" onclick=\"showFivePopOne()\"></div>\n\n      <div id=\"5-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"halfScale\" src=\"/issue1/static/_content/5-pop-1.jpg\" style=\"top:0px;left:115px;\" />\n        <div class=\"abs contentLinkNone\" style=\"top:23px;left:1127px;width:45px;height:43px;\" onclick=\"closeFivePopOne()\"></div>\n        <div class=\"addContentLink\" style=\"top:781px;left:532px;width:95px;height:18px;\">\n          <a href=\"https://www.metalpackagingeurope.org/article/aluminium-beverage-can-recycling-2021-new-record-level-76\" target=\"_blank\"></a>\n        </div>\n      </div>\n      ",
    "script": "\n        function showFivePopOne(){\n          showOverlay('5-pop-1');\n          FivePopOne = new TimelineMax();\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n        \n        function closeFivePopOne(){\n          FivePopOne.stop();\n          hideOverlay('5-pop-1');\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n          hideOverlay('5-pop-1');\n        }\n      ",
    "searchText": "the loop Infrastructure: the role of DRS  adds that collection points should not just  It is no coincidence that several of the  be limited to supermarkets, but should  countries at the top of the recycling league  also be located to capture cans that result  table – Germany, Finland, Norway and  from out-of-home consumption – for  Sweden – have well-managed Deposit  example, at petrol stations, beach  Return Systems (DRS). Where countries  bars, railway stations and airports.  have witnessed a leap in performance, it  inabili sta  ty  is often because newly implemented DRS  Another feature of a successful DRS is  systems are starting to take effect. Take  a decent deposit fee. “In Germany, the  Lithuania as an example – it has seen its  deposit fee, at 25 cents, is the highest in  recycling rate double to almost 90% since  Europe. It is a big motivator for people to  it introduced a DRS two years ago.  bring back their cans,” notes Labberton.  Su  a very clean, uncontaminated material  Section 1  Maarten Labberton, Director of the  stream. “High-quality collection is the  Despite being Europe’s largest  key to maximising can-to-can recycling  beverage can market, the UK has yet  “High-quality  and driving decarbonisation,” says  to implement DRS, which accounts for  Latvia, Slovakia and Malta, all of whom  collection is the  Sandrine Duquerroy-Delesalle, Director  its middling recycling rates. However,  switched to DRS in 2022, and other  key to maximising  of Sustainability & External Affairs at  Tom Giddings, Executive Director of  can-to-can recycling”  CROWN Bevcan EMEA, and member of  not-for-profit aluminium packaging  the MPE Beverage Executive Committee.  recycling organisation Alupro, says that  “With a DRS, the consumer brings the cans  with legislative change looming, the UK  to a reverse vending machine or other  waste management industry is set for  Packaging Group at European Aluminium, says he expects the same to happen in  countries who are in the process of rolling out DRS, including Ireland and Romania.  those countries who have moved to DRS.  Sandrine Duquerroy-Delesalle Member of the  collection point. This means the cans  a shake-up, and one that has the  Others may improve but eventually, they  MPE Beverage  are not contaminated with other  potential to “revolutionise our systems”.  will hit a wall where they cannot improve  Executive Committee  types of packaging or impurities.”  “The most consistent results are from  waste collection systems for Extended  However, the smooth running of a  Legislation: carrots and sticks needed  Producer Responsibility might manage  DRS is reliant on having enough  “This could prove the catalyst we need  any further. Countries operating mixed  05 23  SEE THE STATS  collection points. This is one of the  to see can recycling rates breach 90%  do a good job, but then they will plateau.  teething problems that the Netherlands’  and above,” he says. “It is fair to say that  DRS makes it possible to achieve 90%  fledgling scheme is currently experiencing,  simply relying on consumers to do the  or more,” he says.  according to Labberton. “The Netherlands  right thing won’t achieve 100% beverage  only has half the number of collection  can recycling rates on its own. While the  points it needs, and that is because  ‘carrot’ approach is important, we also  the retailers haven’t invested enough in  need the legislative ‘stick’ to achieve  reverse vending machines,” he says. He  a full push-pull effect.”  70% can recycling, or even 80% if they  A well-designed DRS is such an effective framework for achieving can circularity because the collection methods result in  Click to see the 2021 European beverage can recycling results"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"6-no\" class=\"abs sommet-rounded 6-no-1\" style=\"top:657px; left:668px; font-size:2.8em; font-weight:300; color:#ffffff; margin:0px;\" data-number='{\"to\": 6.8, \"decimals\": 1}' ></h1>\n        <h1 id=\"6-no-1\" class=\"abs sommet-rounded 6-no-1\" style=\"top:657px; left:859px; font-size:2.8em; font-weight:300; color:#ffffff; margin:0px;\" data-number='{\"to\": 1, \"preppend\": \"<\"}' ></h1>\n\n        <img class=\"halfScaleC halfpulsetwo animatedpulse z-index-set\" src=\"/issue1/static/_content/6-img-1.png\" style=\"top:492px;left:948px;\" />\n\n        <div class=\"abs contentLinkNone\" style=\"top:547px;left:1005px;width:145px;height: 125px;\" onclick=\"showSixPopOne()\"></div>\n\n        <div id=\"6-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/issue1/static/_content/6-pop-1.jpg\" style=\"top:0px;left:1007px;\" />\n          <div class=\"abs contentLinkNone\" style=\"top:33px;left:1134px;width:45px;height:43px;\" onclick=\"closeSixPopOne()\"></div>\n        </div>\n\n        <img class=\"halfScaleC halfpulsetwo animatedpulse z-index-set\" src=\"/issue1/static/_content/6-img-2.png\" style=\"top:631px;left:950px;\" />\n\n        <div class=\"abs contentLinkNone\" style=\"top:692px;left:1005px;width:145px;height: 139px;\" onclick=\"showSixPopTwo()\"></div>\n\n        <div id=\"6-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/issue1/static/_content/6-pop-2.jpg\" style=\"top:0px;left:1007px;\" />\n          <div class=\"abs contentLinkNone\" style=\"top:33px;left:1134px;width:45px;height:43px;\" onclick=\"closeSixPopTwo()\"></div>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:788px;left:452px;width:138px;height:20px\">\n          <a href=\"https://european-aluminium.eu/blog/environmental-profile-reports/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim.fromTo(cOf(\"6-no-1\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"6-no-1\")[0]);}}, 1)\n          .fromTo(cOf(\"6-no-1\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"6-no-1\")[1]);}}, 1.2)\n          setTimeout(function(){\n            addContentLinks();\n          },2400)\n        }\n\n        function showSixPopOne(){\n          showOverlay('6-pop-1');\n          SixPopOne = new TimelineMax();\n        }\n\n        function closeSixPopOne(){\n          SixPopOne.stop();\n          hideOverlay('6-pop-1');\n        }\n\n        function showSixPopTwo(){\n          showOverlay('6-pop-2');\n          SixPopTwo = new TimelineMax();\n        }\n\n        function closeSixPopTwo(){\n          SixPopTwo.stop();\n          hideOverlay('6-pop-2');\n        }\n\n        function onPageLeave() {\n          resetNumbers(\"6-no-1\")\n          removeContentLinks()\n          hideOverlay('6-pop-1');\n          hideOverlay('6-pop-2');\n        }\n      ",
    "searchText": "the loop allowing cans to be diverted into  of reform is coming in the UK, including  other applications. We want 100%  a potential mandatory DRS in 2025. For  collection and 100% recycling into  the EU, the most significant piece of  new cans so that we can achieve  legislation on the horizon is the Packaging  our vision of low-carbon cans. The  and Packaging Waste Regulation (PPWR),  more recycled aluminium content we  which has reached a political agreement  can incorporate into beverage cans,  between the European Parliament and  the lower their carbon footprint will  Council and should be officially adopted  be,” says Duquerroy-Delesalle.  in June 2024. However, proponents of DRS are concerned that there are a couple of  Illustrating this point, she says that  Su  aspects of the regulation that could water  the average carbon intensity of virgin  down its impact, namely, the exemption  aluminium production in Europe is  from DRS compliance for Member States  approximately 6.8kg of CO2e per kg,  with a collection rate of over 80% or  a figure that is reduced to less than  existing DRS.  1kg of CO2e for recycled aluminium.  Section 1  inabili sta  ty  According to Giddings, a “tidal wave”  What’s more, aluminium can be On the proposed exemption,  recycled endlessly without deteriorating  Duquerroy-Delesalle says: “This target  in quality, as its atomic structure is  is not ambitious enough; we would have  unchanged by the recycling process.  liked to see it increased to 85 or even 90%. Our concern is that some countries, such as France and Spain, might make the target but will the aluminium they recover can production and will the system  RECYCLED IS BEST  be sustainable in the long run?”  Comparing the  be of a high enough quality for beverage  Even aluminium recovered from the bottom ash of an incinerator has ‘second life’ uses, but for can-to-can recycling, a closed-loop system such as DRS is essential.  06 23  “We need to insist on can-to-can recycling for optimum circularity rather than  approximate carbon intensity of aluminium production (kg of CO2e/kg aluminium)  Source: European Aluminium  6.8KG Virgin aluminium production  <1KG  Click to read more about Alupro  Recycled aluminium production  Click to read more about European Aluminium"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScaleC halfpulsetwo animatedpulse z-index-set\" src=\"/issue1/static/_content/7-img-1.png\" style=\"top:433px;left:966px;\" />\n\n        <div class=\"abs contentLinkNone\" style=\"top:504px;left:1001px;width:100px;height: 166px;\" onclick=\"showSevenPopOne()\"></div>\n\n        <div id=\"7-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/issue1/static/_content/7-pop-1.png\" style=\"top:0px;left:1007px;\" />\n          <div class=\"abs contentLinkNone\" style=\"top:33px;left:1135px;width:45px;height:43px;\" onclick=\"closeSevenPopOne()\"></div>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:506px;left:839px;width:118px;height:19px\">\n          <a href=\"https://international-aluminium.org/can-do-attitude-needed-to-achieve-100-per-cent-recycling-rate-for-all-aluminium-drinks-cans/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:527px;left:716px;width:109px;height:19px\">\n          <a href=\"https://international-aluminium.org/can-do-attitude-needed-to-achieve-100-per-cent-recycling-rate-for-all-aluminium-drinks-cans/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function showSevenPopOne(){\n          showOverlay('7-pop-1');\n          SevenPopOne = new TimelineMax();\n        }\n        \n        function closeSevenPopOne(){\n          SevenPopOne.stop();\n          hideOverlay('7-pop-1');\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n          hideOverlay('7-pop-1');\n        }\n      ",
    "searchText": "the loop  Consumer engagement: an island on a mission Historically, small countries with large tourist populations – Greece and Cyprus, for example – have struggled to establish workable can recycling systems. Recognising the challenges that these countries face, Every Can Counts is collaborating with the Municipality of Antiparos on a pilot can recycling  ty  inabili sta  campaign on this tiny Greek island.  Su  “We have chosen a small island to show, on a small scale, that 100% can recycling  Section 1  can be achieved,” says David Van Heuverswyn, Director of Every Can Counts Europe. Every Can Counts has installed two reverse vending machines (RVMs) in the central bar located in the island’s only village. The machines crush the cans and can also give a deposit – although “We mainly do this through fun,” says  the conference, a near-100% global  Van Heuverswyn. “We don’t patronise  recycling target by 2050 was set  “For now, we are simply showing that  and we try to engage people with key  by industry leaders including  these are easy and fun devices to use  messages, often communicated through  aluminium producers, recyclers,  to foster support for can recycling.  visuals, such as the pixel can wall we  rolling mills, canmakers and  The machines also feature a counter  use at events.”  industry associations.  been recycled and the energy savings  In December, Every Can Counts took  “The quantities we collect in our  this has delivered, and equates this to  its recycling backpacks to COP28 in  backpacks for recycling might be modest,  relatable examples such as hours of  Dubai and joined with other aluminium  but the impact on people’s awareness  phone charge or electric car kilometres,”  industry stakeholders to call for greater  levels is huge,” says Van Heuverswyn. He  says Van Heuverswyn. This is just one  commitment from national governments  wraps up with: “Consumer engagement,  of many initiatives being led by Every  and the aluminium beverage can value  legislation and infrastructure are the  Can Counts, whose remit is encouraging,  chain to accelerate beverage can  three essential ingredients for making  inspiring and empowering consumers  recycling rates, to reach 100%. This  good progress on recycling. Everybody  to recycle their drink cans.  call-to-action was a success: during  has to sing from the same hymn sheet.”  this is not yet the case on Antiparos.  display, which shows how many cans have  07 23  Click to read more about Every Can Counts"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScaleC halfpulsetwo animatedpulse\" src=\"/issue1/static/_content/8-img-1.png\" style=\"top:365px;left:319px;\" />\n\n        <img class=\"halfScaleC\" src=\"/issue1/static/_content/8-img-1a.png\" style=\"top:225px;left:327px;\" />\n\n        <div class=\"abs contentLinkNone\" style=\"top:399px;left:352px;width:82px;height: 80px;\" onclick=\"showEightPopOne()\"></div>\n\n        <div id=\"8-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/issue1/static/_content/8-pop-1.png\" style=\"top:0px;left:115px;\" />\n          <div class=\"abs contentLinkNone\" style=\"top:156px;left:578px;width:45px;height:43px;\" onclick=\"closeEightPopOne()\"></div>\n        </div>\n\n        <img class=\"halfScaleC halfpulsetwo animatedpulse\" src=\"/issue1/static/_content/8-img-3.png\" style=\"top:261px;left:587px;\" />\n\n        <img class=\"halfScaleC\" src=\"/issue1/static/_content/8-img-3a.png\" style=\"top:185px;left:571px;\" />\n\n        <img class=\"halfScaleC\" src=\"/issue1/static/_content/8-img-2a.png\" style=\"top:240px;left:486px;\" />\n\n        <img class=\"halfScaleC halfpulsetwo animatedpulse\" src=\"/issue1/static/_content/8-img-2.png\" style=\"top:424px;left:545px;\" />\n\n        <div class=\"abs contentLinkNone\" style=\"top:458px;left:579px;width:82px;height: 80px;\" onclick=\"showEightPopTwo()\"></div>\n\n        <div id=\"8-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/issue1/static/_content/8-pop-2.png\" style=\"top:0px;left:115px;\" />\n          <div class=\"abs contentLinkNone\" style=\"top:150px;left:525px;width:45px;height:43px;\" onclick=\"closeEightPopTwo()\"></div>\n        </div>\n\n        <div class=\"abs contentLinkNone\" style=\"top:296px;left:620px;width:82px;height: 80px;\" onclick=\"showEightPopThree()\"></div>\n\n        <div id=\"8-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/issue1/static/_content/8-pop-3.png\" style=\"top:0px;left:115px;\" />\n          <div class=\"abs contentLinkNone\" style=\"top:30px;left:228px;width:45px;height:43px;\" onclick=\"closeEightPopThree()\"></div>\n        </div>\n\n        <img class=\"halfScaleC halfpulsetwo animatedpulse\" src=\"/issue1/static/_content/8-img-4.png\" style=\"top:309px;left:780px;\" />\n\n        <img class=\"halfScaleC\" src=\"/issue1/static/_content/8-img-4a.png\" style=\"top:12px;left:670px;\" />\n\n        <div id=\"8-pop-4\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/issue1/static/_content/8-pop-4.png\" style=\"top:0px;left:115px;\" />\n          <div class=\"abs contentLinkNone\" style=\"top:207px;left:393px;width:45px;height:43px;\" onclick=\"closeEightPopFour()\"></div>\n        </div>\n\n        <img class=\"halfScaleC halfpulsetwo animatedpulse\" src=\"/issue1/static/_content/8-img-5.png\" style=\"top:128px;left:813px;\" />\n\n        <img class=\"halfScaleC\" src=\"/issue1/static/_content/8-img-5a.png\" style=\"top:83px;left:777px;\" />\n\n        <div class=\"abs contentLinkNone\" style=\"top:344px;left:813px;width:82px;height: 80px;\" onclick=\"showEightPopFour()\"></div>\n\n        <div class=\"abs contentLinkNone\" style=\"top:161px;left:847px;width:82px;height: 80px;\" onclick=\"showEightPopFive()\"></div>\n\n        <div id=\"8-pop-5\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/issue1/static/_content/8-pop-5.png\" style=\"top:0px;left:115px;\" />\n          <div class=\"abs contentLinkNone\" style=\"top:301px;left:346px;width:45px;height:43px;\" onclick=\"closeEightPopFive()\"></div>\n          <div class=\"addContentLink\" style=\"top:606px;left:1033px;width:78px;height:25px\">\n            <a href=\"https://everycancounts.co.uk/\" target=\"_blank\"></a>\n          </div>\n          <div class=\"addContentLink\" style=\"top:626px;left:751px;width:55px;height:25px\">\n            <a href=\"https://everycancounts.co.uk/\" target=\"_blank\"></a>\n          </div>\n        </div>\n\n        <img class=\"halfScaleC halfpulsetwo animatedpulse\" src=\"/issue1/static/_content/8-img-6.png\" style=\"top:68px;left:932px;\" />\n\n        <img class=\"halfScaleC\" src=\"/issue1/static/_content/8-img-6a.png\" style=\"top:42px;left:882px;\" />\n\n        <div class=\"abs contentLinkNone\" style=\"top:101px;left:945px;width:82px;height: 80px;\" onclick=\"showEightPopSix()\"></div>\n\n        <div id=\"8-pop-6\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/issue1/static/_content/8-pop-6.png\" style=\"top:0px;left:115px;\" />\n          <div class=\"abs contentLinkNone\" style=\"top:258px;left:739px;width:45px;height:43px;\" onclick=\"closeEightPopSix()\"></div>\n        </div>\n\n        <img class=\"halfScaleC\" src=\"/issue1/static/_content/8-img-7.png\" style=\"top:663px;left:738px;\" />\n        <div class=\"addContentLink\" style=\"top:780px;left:890px;width:188px;height:37px\">\n          <a href=\"https://www.canroadmap2030.eu/\" target=\"_blank\"></a>\n        </div>\n        ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function showEightPopOne(){\n          showOverlay('8-pop-1');\n          EightPopOne = new TimelineMax();\n        }\n\n        function closeEightPopOne(){\n          EightPopOne.stop();\n          hideOverlay('8-pop-1');\n        }\n\n        function showEightPopTwo(){\n          showOverlay('8-pop-2');\n          EightPopTwo = new TimelineMax();\n        }\n\n        function closeEightPopTwo(){\n          EightPopTwo.stop();\n          hideOverlay('8-pop-2');\n        }\n\n        function showEightPopThree(){\n          showOverlay('8-pop-3');\n          EightPopThree = new TimelineMax();\n        }\n\n        function closeEightPopThree(){\n          EightPopThree.stop();\n          hideOverlay('8-pop-3');\n        }\n\n        function showEightPopFour(){\n          showOverlay('8-pop-4');\n          EightPopFour = new TimelineMax();\n        }\n\n        function closeEightPopFour(){\n          EightPopFour.stop();\n          hideOverlay('8-pop-4');\n        }\n\n        function showEightPopFive(){\n          removeContentLinks()\n          showOverlay('8-pop-5');\n          EightPopFive = new TimelineMax();\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function closeEightPopFive(){\n          EightPopFive.stop();\n          hideOverlay('8-pop-5');\n        }\n\n        function showEightPopSix(){\n          showOverlay('8-pop-6');\n          EightPopSix = new TimelineMax();\n        }\n\n        function closeEightPopSix(){\n          EightPopSix.stop();\n          hideOverlay('8-pop-6');\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n          hideOverlay('8-pop-1');\n          hideOverlay('8-pop-2');\n          hideOverlay('8-pop-3');\n          hideOverlay('8-pop-4');\n          hideOverlay('8-pop-5');\n          hideOverlay('8-pop-6');\n        }\n      ",
    "searchText": "the loop  O T D  HE  T  inabili sta  ty  Su  Section 1  0 1 1  This roadmap sets out our ambitious vision of a 100% recycling rate for aluminium beverage cans in Europe by 2030. 08 23  % 0  A O R  Click each crate to follow the journey.  6  5 3  4  2  Collaboration is vital  Inspiring consumers to contribute  Aluminium recovery where necessary  Increasing waste sorting efficiency Optimising can collection The journey so far  Based on the MPE Beverage and European Aluminium roadmap. Click to learn more"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 9-title\" style=\"top: 653px;left: 142px;\" src=\"/issue1/static/_content/9-title-1.png\" />\n        <img class=\"abs halfScale 9-title\" style=\"top: 753px;left: 254px;\" src=\"/issue1/static/_content/9-title-2.png\" />\n        <img class=\"abs halfScale 9-title\" style=\"top: 664px;left: 682px;\" src=\"/issue1/static/_content/9-sub-1.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax();\n          pg9Anim.staggerFromTo(cOf(\"9-title\"), 0.5, {x:30,opacity:0}, {x:0, opacity:1, ease: Power2.easeNone}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "the loop  D  Traditionally, cans were the format of choice for global soft drinks and mass-market beer brands. However, in recent years, a host of exciting brands have started using the format in exciting new ways – from small craft breweries through to vineyards and pre-mixed cocktail companies.  rinks brands are experimenting with  vibrant colourways, different can sizes and cutting-edge printing and finishing embellishments, and these eye-catching innovations are helping  Written by Simon Creasey ovation nn  to drive major growth across the beverage market. But what’s  I  attracting these new brands and consumers to this traditional  Section 2  packaging format?  INDUSTRY INNOVATION  A SPOTLIGHT ON TRAILBLAZING CANNED BEVERAGE BRANDS  9 23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 10-bg\" style=\"top: -114px;left: 203px;\" src=\"/issue1/static/_content/10-bg-1.png\" />\n\n        <img class=\"abs halfScale 10-title\" style=\"top: 122px;left: 551px;\" src=\"/issue1/static/_content/10-title-1.png\" />\n\n        <img class=\"abs halfScaleC 10-icon\" style=\"top: 124px;left: 480px;\" src=\"/issue1/static/_content/10-icon-1.png\" />\n        <img class=\"abs halfScaleC 10-icon\" style=\"top: 170px;left: 667px;\" src=\"/issue1/static/_content/10-icon-2.png\" />\n        <img class=\"abs halfScaleC 10-icon\" style=\"top: 89px;left: 774px;\" src=\"/issue1/static/_content/10-icon-3.png\" />\n        <img class=\"abs halfScaleC 10-icon\" style=\"top: 170px;left: 901px;\" src=\"/issue1/static/_content/10-icon-4.png\" />\n        <img class=\"abs halfScaleC 10-icon\" style=\"top: 170px;left: 1009px;\" src=\"/issue1/static/_content/10-icon-5.png\" />\n\n        <img class=\"abs halfScale 10-text\" style=\"top: 410px;left: 578px;\" src=\"/issue1/static/_content/10-text-1.png\" />\n        <img class=\"abs halfScale 10-text\" style=\"top: 408px;left: 723px;\" src=\"/issue1/static/_content/10-text-2.png\" />\n        <img class=\"abs halfScale 10-text\" style=\"top: 410px;left: 823px;\" src=\"/issue1/static/_content/10-text-3.png\" />\n        <img class=\"abs halfScale 10-text\" style=\"top: 412px;left: 942px;\" src=\"/issue1/static/_content/10-text-4.png\" />\n        <img class=\"abs halfScale 10-text\" style=\"top: 409px;left: 1073px;\" src=\"/issue1/static/_content/10-text-5.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax();\n          pg10Anim.fromTo(cOf(\"10-bg\"), 0.3, {scale:0}, {scale:0.5, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"10-title\"), 0.6, {x:30,opacity:0}, {x:0, opacity:1, ease: Power2.easeNone}, 0.3, 1.2)\n          .staggerFromTo(cOf(\"10-icon\"), 0.5, {scale:0}, {scale:0.5, ease: Power2.easeOut}, 0.1, 1.2)\n          .staggerFromTo(cOf(\"10-text\"), 0.5, {y:30,opacity:0}, {y:0, opacity:1, ease: Power2.easeNone}, 0.1, 1.3)\n        }\n\n        function onPageLeave() {\n          pg10Anim.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "the loop According to Gareth Roberts, design director at brand acceleration agency bluemarlin, which specialises in drinks  WHY BEVERAGE BRANDS LOVE CANS  marketing, beverage cans offer beverage brands numerous different benefits. Firstly, the practicalities – cans are lightweight and easy to transport, which reduces transportation costs for brand ovation nn  owners and makes them more convenient for on-the-go consumers.  I  In addition to their portability, cans help to preserve product quality and  Section 2  extend shelf life. “Cans provide excellent protection against light and air, helping to preserve the freshness and quality of the beverage inside,” explains Roberts. “This is especially important for products sensitive  Perfectly portioned  Quick to chill  to oxygen or UV light.” Of course, cans also boast strong sustainability credentials. “Aluminium cans are highly recyclable, and the  10 23  recycling process requires less energy  The sustainability benefits of aluminium  compared to manufacturing new cans  inspired the birth of the Canned  from raw materials,” says Roberts.  Wine Company, which sells a range  “Aluminium cans also have a lower  of award-winning wines in colourful  environmental impact compared  cans. “Packaging is one of the largest  to some other packaging materials.  contributions to emissions in the wine  The aluminium industry has made  industry, so this felt important to address,”  efforts to promote sustainability, and  says Elena Whitehead, marketing and  many consumers are environmentally  brand manager at the Canned Wine  conscious and increasingly drawn to  Company. “Our cans produce around  brands that prioritise eco-friendly  70% fewer CO2 emissions per litre than  packaging – making recyclability a  glass bottles and have an average  significant selling point.”  of 70% recycled content.”  Protects from light and air, keeping drinks fresh  Incredibly customisable  Infinitely recyclable"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "the loop As well as appealing to consumers, who  “We partner with festivals and music  are increasingly factoring environmental  venues, and we have seen that people  concerns into their purchasing decisions,  are using cans to moderate their intake  canned wine products – which have  further by alternating regular Most  grown enormously in popularity over  Wanted cans with our non-alc fizz.”  ovation nn  the last few years – also capitalise on  I  Section 2  another rapidly emerging consumer  In addition to the potential health and  trend, according to Whitehead. “The  sustainability benefits the packaging  portioning of our cans ties in with the  format offers, cans also present a blank  growing trend of moderation. When you  template for a brand to customise,  choose to only have one drink, you’re  which can provide great stand-out  going to make sure it’s a great one.  on-shelf. “When it comes to design,  I’m a big proponent of drinking less,  brands can use the entire surface area  but drinking better,” she says.  of a can for branding and marketing purposes, allowing for eye-catching  It’s a trend also identified by Sarah  graphics, logos, and promotional  Atkins, brand manager at Off-Piste  messages,” explains Tom Harvey,  Wines. Off-Piste entered the canned  co-founder of YesMore Drinks  wine category in Europe in 2017, having  Marketing Agency.  seen the success of the format in the US and spotted a gap in the market  Innovative new printing technology  at home. In addition to producing the  increasingly allows for even more  Most Wanted wine brand, which is  vibrant and creative designs to be  available in bottles and cans, the firm  printed onto cans, agrees Roberts.  also sells the canned PinotPinot brand.  “Advances in techniques such as  The two brands together account for  “Our cans produce  thermal inks and direct-to-can printing  63% of the UK canned wine market,  around 70% fewer  have meant that creativity has been  according to Atkins.  CO2 emissions  unleashed on cans in recent years,  per litre than  with small batch and micro-breweries,  “Wine drinkers across the board are  glass bottles”  alongside other smaller drinks  increasingly moderating, so cans now offer a great solution to those ‘just one glass’ occasions. This trend of  11 23  moderation is one of the reasons we decided to launch our 0.5% Sauvignon Fizz in this format,” says Atkins.  manufacturers, able to create stunning  Elena Whitehead Marketing & Brand Manager, Canned Wine Co.  designs that punch above their weight against more established brands in their category. In turn, this freedom of production has helped to create a subculture of small-batch, low-quantity"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.png",
    "zoom": null,
    "content": "        \n        <div class=\"abs addContentLink\" style=\"top:238px;left:450px;width:75px;height: 21px;\" onclick=\"showTwelvePopOne()\"></div>\n\n        <div id=\"12-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/issue1/static/_content/12-pop-1.png\" style=\"top:345px;left:432.5px;\" />\n          <div class=\"abs contentLinkNone\" style=\"top:772px;left:1088px;width:45px;height:43px;\" onclick=\"closeTwelvePopOne()\"></div>\n        </div>\n        ",
    "script": "\n          function onPageEnter() {\n            setTimeout(function(){\n              addContentLinks();\n            },1000)\n          }\n\n          function showTwelvePopOne(){\n            showOverlay('12-pop-1');\n            TwelvePopOne = new TimelineMax();\n          }\n          \n          function closeTwelvePopOne(){\n            TwelvePopOne.stop();\n            hideOverlay('12-pop-1');\n          }\n\n          function onPageLeave() {\n            removeContentLinks()\n            hideOverlay('12-pop-1');\n          }\n      ",
    "searchText": "the loop can printing designs that buck the trends  Canned alcoholic beverages can  bright future for the packaging format  of their category both aesthetically and  sometimes suffer from the perception  in the beverage sector. “Cans offer  in their formulation.”  that they are less premium. “It’s a job  a broad range of benefits, and their  for marketers like me to help educate  popularity continues to grow,” he says.  and guide the audience that that’s not  “Brands are increasingly recognising  the case,” says Harvey. However,  the advantages of cans, not only for  consumer perception of canned drink  practical reasons like preservation  quality is shifting with every exciting  and portability, but also for their  new canned drink that hits the market,  positive impact on brand image  according to Roberts, who predicts a  and sustainability efforts.”  Another major advantage cans offer brands over other types of packaging in the beverage space is the novelty factor. Ready-to-drink premixed cocktails are ovation nn  relatively new to the market, and whilst winemaking is an ancient tradition, canning wine is not. The new format  I  provides a fresh feel, which particularly  Section 2  appeals to younger consumers. Harvey adds more context. “Whilst beer sold in cans is commonplace, some consumers still find it novel and modern to see wine or cocktails sold in cans. This can help position a brand towards a younger audience. For example, some wine brands can be seen as stuffy or snobby, but simply packaging the same liquid in a whole new way, potentially with more approachable branding, can attract an entirely new audience.” That’s not to say the format isn’t without its challenges for brand owners, especially wine drinkers who are used to transparent bottles. ' still not primarily associated with wines, so there is a design challenge in getting across that a) this is a wine,  12 23  and b) what the wine inside tastes like, from the packaging alone,” says Whitehead.  ONES TO WATCH Click here to reveal Tom Harvey's top beverage brand picks"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 13-title\" style=\"top: 154px;left: 659px;\" src=\"/issue1/static/_content/13-title-1.png\" />\n        <img class=\"abs halfScale 13-title\" style=\"top: 203px;left: 650px;\" src=\"/issue1/static/_content/13-title-2.png\" />\n        <img class=\"abs halfScale 13-title\" style=\"top: 393px;left: 655px;\" src=\"/issue1/static/_content/13-title-3.png\" />\n        <img class=\"abs halfScale 13-title\" style=\"top:451px;left: 659px;\" src=\"/issue1/static/_content/13-sub-1.png\" />\n\n        <div class=\"addContentLink\" style=\"top:552px;left:980px;width:140px;height:24px\">\n          <a href=\"https://laboiteboisson.com/\" target=\"_blank\"></a>\n        </div>\n        ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax();\n          pg13Anim.staggerFromTo(cOf(\"13-title\"), 0.6, {x:30,opacity:0}, {x:0, opacity:1, ease: Power2.easeNone}, 0.3, 1)\n          setTimeout(function(){\n            addContentLinks();\n          },2400)\n        }\n\n        function onPageLeave() {\n          pg13Anim.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "the loop  2023  ovation nn  THE  I  Section 2  CANETTES D’OR AWARDS THE FRENCH BEVERAGE CANS MARKET GATHERS PACE The Canettes d’Or awards, organised by La Boîte Boisson every two years, recognise and celebrate new beverage launches in cans and brands that are committed to excellence in can design and innovation on the French market.  Written by Iris Arsic  13 23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScaleC halfpulsetwo animatedpulse z-index-set\" src=\"/issue1/static/_content/14-icon-1.png\" style=\"top:479px;left:325px;\" />\n\n        <div class=\"abs contentLinkNone\" style=\"top:508px;left:417px;width:246px;height:83px;\" onclick=\"showFourteenPopOne()\"></div>\n\n        <div id=\"14-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/issue1/static/_content/14-pop-1.png\" style=\"top:0px;left:114px;\" />\n          <div class=\"abs contentLinkNone\" style=\"top:134px;left:1118px;width:45px;height:43px;\" onclick=\"closeFourteenPopOne()\"></div>\n        </div>\n\n        <img class=\"halfScaleC halfpulsetwo animatedpulse z-index-set\" src=\"/issue1/static/_content/14-icon-2.png\" style=\"top:575px;left:332px;\" />\n\n        <div class=\"abs contentLinkNone\" style=\"top:600px;left:417px;width:246px;height:95px;\" onclick=\"showFourteenPopTwo()\"></div>\n\n        <div id=\"14-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/issue1/static/_content/14-pop-2.png\" style=\"top:0px;left:114px;\" />\n          <div class=\"abs contentLinkNone\" style=\"top:186px;left:1118px;width:45px;height:43px;\" onclick=\"closeFourteenPopTwo()\"></div>\n        </div>\n\n        <img class=\"halfScaleC halfpulsetwo animatedpulse z-index-set\" src=\"/issue1/static/_content/14-icon-3.png\" style=\"top:54px;left:742px;\" />\n\n        <div class=\"abs contentLinkNone\" style=\"top:87px;left:844px;width:255px;height:102px;\" onclick=\"showFourteenPopThree()\"></div>\n\n        <div id=\"14-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/issue1/static/_content/14-pop-3.png\" style=\"top:0px;left:805px;\" />\n          <div class=\"abs contentLinkNone\" style=\"top:29px;left:1154px;width:45px;height:43px;\" onclick=\"closeFourteenPopThree()\"></div>\n          <div class=\"addContentLink\" style=\"top:487px;left:953px;width:195px;height:19px\">\n            <a href=\"https://csa.eu/\" target=\"_blank\"></a>\n          </div>\n        </div>\n\n        <img class=\"halfScaleC halfpulsetwo animatedpulse z-index-set\" src=\"/issue1/static/_content/14-icon-4.png\" style=\"top:172px;left:730px;\" />\n\n        <div class=\"abs contentLinkNone\" style=\"top:206px;left:844px;width:282px;height:102px;\" onclick=\"showFourteenPopFour()\"></div>\n\n        <div id=\"14-pop-4\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"halfScale\" src=\"/issue1/static/_content/14-pop-4.png\" style=\"top:0px;left:699px;\" />\n          <div class=\"abs contentLinkNone\" style=\"top:29px;left:1154px;width:45px;height:43px;\" onclick=\"closeFourteenPopFour()\"></div>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:628px;left:211px;width:40px;height:20px\">\n          <a href=\"https://www.citeo.com/\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:628px;left:251px;width:110px;height:20px\">\n          <a href=\"https://everycancounts.eu/fr/etapes-recyclage-fr/  \" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:647px;left:140px;width:61px;height:20px\">\n          <a href=\"https://everycancounts.eu/fr/etapes-recyclage-fr/  \" target=\"_blank\"></a>\n        </div>\n        ",
    "script": "\n          function onPageEnter() {\n            setTimeout(function(){\n              addContentLinks();\n            },1000)\n          }\n\n          function showFourteenPopOne(){\n            showOverlay('14-pop-1');\n            FourteenPopOne = new TimelineMax();\n          }\n          \n          function closeFourteenPopOne(){\n            FourteenPopOne.stop();\n            hideOverlay('14-pop-1');\n          }\n\n          function showFourteenPopTwo(){\n            showOverlay('14-pop-2');\n            FourteenPopTwo = new TimelineMax();\n          }\n          \n          function closeFourteenPopTwo(){\n            FourteenPopTwo.stop();\n            hideOverlay('14-pop-2');\n          }\n\n          function showFourteenPopThree(){\n            removeContentLinks();\n            showOverlay('14-pop-3');\n            FourteenPopThree = new TimelineMax();\n            setTimeout(function(){\n              addContentLinks();\n            },1000)\n          }\n          \n          function closeFourteenPopThree(){\n            FourteenPopThree.stop();\n            hideOverlay('14-pop-3');\n          }\n\n          function showFourteenPopFour(){\n            showOverlay('14-pop-4');\n            FourteenPopFour = new TimelineMax();\n          }\n          \n          function closeFourteenPopFour(){\n            FourteenPopFour.stop();\n            hideOverlay('14-pop-4');\n          }\n\n          function onPageLeave() {\n            removeContentLinks()\n            hideOverlay('14-pop-1');\n            hideOverlay('14-pop-2');\n            hideOverlay('14-pop-3');\n          }\n      ",
    "searchText": "the loop  U  nderscoring the importance  As Lucien Debever, who heads both  of recycling and sustainable  La Boîte Boisson and the Chaque Canette  initiatives, not only for consumers but  Compte programme, explains, the award  for the good of the planet, the awards  categories vary each time, with two  also recognise non-profits committed  new categories added in 2023: one for  to promoting out-of-home can collection  soft drinks in the international category  across the country.  and another for alcoholic beverages.  The fourth and most recent edition  design innovation in other countries  of Canettes d’Or drew over 200 entries,  given that lots of brands participating  the highest total since the awards  Click to read more  in our competition also manufacture  were first presented in 2017. Seventeen  cans outside France. It is a way to open  winners were revealed at a ceremony  the Canettes d’Or awards to international  held in Paris in November 2023. A panel  candidates and make them shine,  of judges, comprising representatives  too,” he adds.  ovation nn I  Section 2  from MPE, as the sponsor of the Canettes d’Or awards, the trade association of the Brazilian aluminium beverage can industry Abralatas, and La Boîte Boisson,  2023 WINNERS  along with other key figures in trade  Click below to reveal winners  media, design and marketing, assessed submissions in 10 categories, with 11 winners decided by the judges and one winner through a public vote. In partnership with the French non-profit Citeo, Chaque Canette Compte, the French offshoot of Every Can Counts, a pan-European umbrella brand for promoting on-the-go recycling of beverage metal containers, whose representatives were also on the panel of experts, five additional winners  23  Click to read more  The rise of cans as a sustainable packaging solution  “We felt that it was good to showcase  14  France sees spike in canned beverage sales  were selected for their effective beverage can recycling projects and sustainability initiatives.  New beverage cans, innovations and brand sustainability Beverage can recycling projects and sustainability initiatives"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 15-title-1\" style=\"top: 77px;left: 173px;\" src=\"/issue1/static/_content/15-title-1.png\" />\n        <img class=\"abs halfScale 15-title-2\" style=\"top: 181px;left: 172px;\" src=\"/issue1/static/_content/15-title-2.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim.fromTo(cOf(\"15-title-1\"), 0.6, {x:30,opacity:0}, {x:0, opacity:1, ease: Power2.easeNone}, 1)\n          .fromTo(cOf(\"15-title-2\"), 0.6, {y:30,opacity:0}, {y:0, opacity:1, ease: Power2.easeNone}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "the loop  OPPORTUNITIES AHEAD  ustry Ind  With a strong track record on recycling and growing enthusiasm for the packaging format, the beverage can sector ought to view 2024 with optimism. Challenges including upcoming legislation and a race to net-zero will focus minds and encourage collaboration.  Section 3  Written by Philip Chadwick  T  here are many reasons for the beverage can sector to be cheerful. Aluminium remains a hugely popular material for  drinks brands and the year ahead should give the industry cause for optimism. The segment’s strong recycling record means that it is well-placed to deal with the changing legislative landscape. Plus, more and more consumers are enjoying beverages in the aluminium can format – for reasons including its strong sustainability credentials, its convenience and an undeniable cool factor. In general, the European can market looks to at least remain stable for the next few years,  15 23  with modest growth perspectives in specific markets."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "the loop Across Europe, the demand for beverage cans has increased as consumer behaviour shifts. Many welcome the move from plastic, but a younger generation is also keen to try out new products. Soft drinks, water, energy drinks, health-focused drinks and ready-to-drink cocktails are among the segments on the up, and demanding aluminium. And with that ustry Ind  demand set to climb, the packaging supply chain will need to bear in mind the evolving legislative landscape.  Evolving legislation Section 3  The European Commission published a proposal to revise the Packaging and Packaging Waste Regulation (PPWR). The revised regulation aims to tackle the increase in packaging waste generated The segment can also point to a  Legislators are pushing ahead with laws  in the EU, while harmonising the internal  strong recycling record across Europe;  aiming to stretch the sector while net zero  market for packaging and boosting the  Metal Packaging Europe (MPE) says  remains on the radar. Designers are also  circular economy. MPE worked with  that the industry is well placed to  having to raise their game as competition  the Member States and the Members  contribute to the continent’s circular  between brands heats up.  of the European Parliament to improve  economy goals with 76% of aluminium  16 23  some provisions in the proposal related  cans recycled in 2021. According to MPE's  Shifting consumer behaviour  to definitions (ensuring legal certainty  data, the European aluminium beverage  Over the past few years, the drive  through clear definition and for the first  can market hit 96 billion units in 2022,  towards improved sustainable practices  time introducing the definition of high-  up from 92 billion in 2021. Increasing  has been pushed by consumers and  quality recycling), complementarity  beverage can sales have translated into  lawmakers. The war on single-use plastic  between recyclable and reusable  growing investment from brands into can  has meant that all packaging materials  packaging, recyclability, eco-modulation  filling lines, showing commitment to the  have had to raise their game on circularity.  of extended producer responsibility  format and confidence in its future.  The beverage market is no exception.  (EPR) fees, exemption from reuse targets,  With plastic reduction welcomed by  review of waste prevention targets  But for all the impressive figures and  citizens, the aluminium can format  proposal, and support for mandatory  projections, the market needs to be wary.  has been able to flourish.  deposit return schemes."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 17-bg-1\" style=\"top: -310px;left: 646px;\" src=\"/issue1/static/_content/17-bg-1.png\" />\n        <img class=\"abs halfScale 17-title-1\" style=\"top: 100px;left: 734px;\" src=\"/issue1/static/_content/17-title-1.png\" />\n        <img class=\"abs halfScale 17-line-1\" style=\"top: 163px;left: 743px;\" src=\"/issue1/static/_content/17-line-1.png\" />\n        <img class=\"abs halfScaleC 17-img-1\" style=\"top: 109px;left: 664px;\" src=\"/issue1/static/_content/17-img-1.png\" />\n        <h1 id=\"17-no\" class=\"abs sommet-rounded 17-no\" style=\"top:229px; left:763px; font-size:2.4em; font-weight:300; color:#fbe61e; margin:0px;\" data-number='{\"to\": 76}' ></h1>\n        <img class=\"abs halfScale 17-line-2\" style=\"top: 351px;left: 743px;\" src=\"/issue1/static/_content/17-line-2.png\" />\n        <img class=\"abs halfScaleC 17-img-2\" style=\"top: 250px;left: 689px;\" src=\"/issue1/static/_content/17-img-2.png\" />\n        <h1 id=\"17-no\" class=\"abs sommet-rounded 17-no\" style=\"top:527px; left:742px; font-size:2.4em; font-weight:300; color:#fbe61e; margin:0px;\" data-number='{\"to\": 96}' ></h1>\n        <img class=\"abs halfScale 17-line-3\" style=\"top: 609px;left: 743px;\" src=\"/issue1/static/_content/17-line-3.png\" />\n        <img class=\"abs halfScaleC 17-img-3\" style=\"top: 580px;left: 705px;\" src=\"/issue1/static/_content/17-img-3.png\" />\n        <img class=\"abs halfScale 17-text-1\" style=\"top: 724px;left: 749px;\" src=\"/issue1/static/_content/17-text-1.png\" />\n        <h1 id=\"17-no\" class=\"abs sommet-rounded 17-no\" style=\"top:736px; left:753px; font-size:2.4em; font-weight:300; color:#fbe61e; margin:0px;\" data-number='{\"to\": 100}' ></h1>\n\n        <div class=\"addContentLink\" style=\"top:324px;left:517px;width:153px;height:20px\">\n          <a href=\"https://www.canroadmap2030.eu/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:344px;left:427px;width:73px;height:20px\">\n          <a href=\"https://www.canroadmap2030.eu/\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:284px;left:898px;width:200px;height:30px\">\n          <a href=\"https://european-aluminium.eu/blog/netzeroby2050/\" target=\"_blank\"></a>\n        </div>\n        ",
    "script": "\n          function onPageEnter() {\n            pg17Anim = new TimelineMax();\n            pg17Anim.fromTo(cOf(\"17-bg-1\"), 0.4, {scale:0}, {scale:0.5, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"17-title-1\"), 0.3, {y:20,opacity:0}, {y:0, opacity:1, ease: Power2.easeNone}, 1.1)\n            .fromTo(cOf(\"17-line-1\"), 0.3, {y:20,opacity:0}, {y:0, opacity:1, ease: Power2.easeNone}, 1.2)\n            .fromTo(cOf(\"17-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"17-no\")[0], 0.3, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[0]);}}, 1.3)\n            .fromTo(cOf(\"17-line-2\"), 0.3, {y:20,opacity:0}, {y:0, opacity:1, ease: Power2.easeNone}, 1.4)\n            .fromTo(cOf(\"17-img-2\"), 0.3, {scale:0}, {scale:0.5, ease: Power2.easeOut}, 1.5)\n            .fromTo(cOf(\"17-no\")[1], 0.3, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[1]);}}, 1.5)\n            .fromTo(cOf(\"17-line-3\"), 0.3, {y:20,opacity:0}, {y:0, opacity:1, ease: Power2.easeNone}, 1.6)\n            .fromTo(cOf(\"17-img-3\"), 0.3, {scale:0}, {scale:0.5, ease: Power2.easeOut}, 1.7)\n            .fromTo(cOf(\"17-text-1\"), 0.3, {y:10,opacity:0}, {y:0, opacity:1, ease: Power2.easeNone}, 1.8)\n            .fromTo(cOf(\"17-no\")[2], 0.3, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[2]);}}, 1.8)\n            setTimeout(function(){\n              addContentLinks();\n            },2800)\n          }\n\n          function onPageLeave() {\n            pg17Anim.stop()\n            removeContentLinks()\n            resetNumbers(\"17-no\")\n          }\n      ",
    "searchText": "the loop Packaging should not just be designed for  beverage container return rates rose from  recycling and should also be able to be  34% to 92% in less than two years after  effectively and efficiently separated from  introducing a DRS scheme in 2016.  IN NUMBERS  THE EUROPEAN CAN MARKET  Section 3  ustry Ind  for countries to reach net-zero  well-placed for this for many reasons:  MPE believes that well-designed systems  The aim is to hit the target by  their recycling is based on existing  can play a role in helping to achieve  2050 and the aluminium industry  infrastructure, they are easy to sort,  the circular economy ambitions of the  is committed to playing its part.  don’t involve mixed materials or need  beverage industry in the EU. Indeed,  to be separated by colour, no additional  it goes further and adds that these  investment is required – such as the  schemes are pivotal to hitting close to  tethered caps being introduced for  100% recycling by 2030. This target is  plastic bottles – and recycling rates are,  set out in the Beverage Can Recycling  of course, already high.  Roadmap. A DRS can also go some  proposals – could help achieve  way to saving energy, minimising the  a 94% reduction in emissions by  In addition, the MPE view is that criteria  need for virgin materials and reducing  2050. Clean energy will also play a  to assess recyclability should be clear,  carbon emissions. Substituting virgin  fundamental role towards this goal.  harmonised among materials, and  materials with recycled materials allows  enforceable. Recyclable packaging formats  for significant energy savings during the  While green targets and legislation  should be collected, sorted and recycled  manufacturing phase – the International  shape the market, creativity remains  at scale into secondary materials with  Aluminium Institute states that using  at an all-time high for the beverage  sufficient quality to substitute primary  recycled aluminium can add up to  can sector. With more craft brands  raw materials. MPE also believes that  energy savings of 95%.  some highly recyclable single-use  23  In addition, global pressure emissions is unlikely to recede.  the waste stream. Cans are particularly  17  Building pressure  packaging should be exempted from  While MPE supports making DRS  PPWR’s reuse targets.  mandatory, it warns that it is against  76% of cans  Despite the manufacturing of beverage cans being energy-intensive, a report by European Aluminium cites that a switch to electric-based  recycled in 2021  technologies – among other  96  looking to challenge more established  produced in 2022  manufacturers is helping them,  BILLION cans  brands, designers have had to raise their game. Technology from  the exemption based on the rate of  whether via high-resolution printing  Carefully designed infrastructure  separate collection of 80% by weight  that spans 360 degrees on a can or  A well-functioning Deposit Return  of such packaging placed on the market  contemporary matte finishes that  System (DRS) can play a part in capturing  on the territory of a Member State.  offer a tactile feel for consumers.  aluminium. There are plenty of examples  MPE considers that this is against the  across Europe where this has taken place.  ambition of the European Union to show  In Slovakia, 100 million metal cans and  its leadership in the circular economy.  plastic bottles were collected after just  The exemption based on the 90%  five months of operation. Denmark’s  collection targets proposed by the  DRS has a redemption rate as high as  European Commission is the most  93% for drinks containers. In Lithuania,  acceptable for MPE.  Goal of  100%  of cans recycled by 2030  The beverage can market isn’t standing still when it comes to innovation, and while legislation can create fresh challenges, it can’t dampen a sector that’s well set for growth."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 18-title-1\" style=\"top: 276px;left: 120px;\" src=\"/issue1/static/_content/18-title-1.png\" />\n        <img class=\"abs halfScale 18-title-2\" style=\"top: 358px;left: 190px;\" src=\"/issue1/static/_content/18-title-2.png\" />\n        <img class=\"abs halfScale 18-title-3\" style=\"top: 491px;left: 524px;\" src=\"/issue1/static/_content/18-title-3.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim.fromTo(cOf(\"18-title-1\"), 0.5, {y:-30,opacity:0}, {y:0, opacity:1, ease: Power2.easeNone}, 1)\n          .fromTo(cOf(\"18-title-2\"), 0.5, {x:30,opacity:0}, {x:0, opacity:1, ease: Power2.easeNone}, 1.3)\n          .fromTo(cOf(\"18-title-3\"), 0.6, {y:30,opacity:0}, {y:0, opacity:1, ease: Power2.easeNone}, 1.6)\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "the loop  The beverage can market knows it has to make moves towards becoming carbon neutral. It’s not an easy challenge, but the sector appears ready to take it on.  Section 3  ustry Ind  THE PURSUIT OF  NET ZERO  CARBON CUTS FOR CANMAKERS  Written by Philip Chadwick  T  he clock is ticking. The year 2050  might seem a long way off, but when it comes to the push towards net-zero greenhouse gas emissions there is a need to act swiftly. The EU’s target to be climate neutral by 2050 requires action across supply chains – the beverage can market is no exception.  18 23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:546px;left:593px;width:80px;height:20px\">\n          <a href=\"https://european-aluminium.eu/wp-content/uploads/2023/11/23-11-14-Net-Zero-by-2050-Science-based-Decarbonisation-Pathways-for-the-European-Aluminium-Industry_FULL-REPORT.pdf\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:566px;left:428px;width:250px;height:40px\">\n          <a href=\"https://european-aluminium.eu/wp-content/uploads/2023/11/23-11-14-Net-Zero-by-2050-Science-based-Decarbonisation-Pathways-for-the-European-Aluminium-Industry_FULL-REPORT.pdf\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:606px;left:428px;width:60px;height:20px\">\n          <a href=\"https://european-aluminium.eu/wp-content/uploads/2023/11/23-11-14-Net-Zero-by-2050-Science-based-Decarbonisation-Pathways-for-the-European-Aluminium-Industry_FULL-REPORT.pdf\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "the loop Pressure is on but in this sector,  Taking alignment with the IPCC’s 1.5°C  decarbonisation is not simple. There is a  scenario as its north star, this study  plan, however – the supply chain has set  provides a comprehensive overview  out a strategy to reduce its carbon impact,  of the technological solutions that will  including investing in new technology.  be needed across the entire European  Rethinking the manufacturing process  aluminium value chain and offers  could help move the needle to net zero.  recommendations for a policy framework that will allow these various solutions  “Unlike most other packaging materials,  to deliver on their potential.”  Section 3  ustry Ind  aluminium is infinitely recyclable,” explains Tom Giddings, executive director at trade  Key findings in the report include a  association Alupro. “With the opportunity  goal to achieve a 92.4% reduction in  to offset virgin manufacture through  greenhouse gas emissions by 2050.  recycling, the industry is able to reduce  To hit this target, a shift is required  its carbon footprint and accelerate wider  towards electric-powered technology  progress towards a net-zero society.”  in aluminium manufacturing – such as alumina refining and smelting processes.  Alupro's data shows that up to 95% of  A clear path ahead for aluminium suppliers  But to do this, the industry needs to  emissions are saved by using recycled aluminium instead of primary aluminium  In November last year, European  developing new smelter facilities.  to make new products.  Aluminium launched a report in  Ultimately, R&D spend will determine  partnership with Ramboll. Net-zero by  how fast the sector can decarbonise.  energy consumption and resulting carbon  “Broadly speaking, recycling offers  2050: Science Based Decarbonisation  a number of benefits over virgin  Pathways for the European Aluminium  In amongst this is a clear need for  manufacture, including reduced energy  Industry is a study that provides a  legislative support. The report outlines  consumption, lower greenhouse gas  roadmap for reducing emissions  emissions, conservation of resources  while maintaining growth.  and waste reduction,” adds Giddings.  19 23  spend significantly, particularly in  “From an aluminium perspective, there  In the foreword, European Aluminium’s  are a number of decarbonisation  director general Paul Voss writes:  benefits to recycling. Aluminium can be  “Since aluminium is both a significant  recycled again and again with no loss of  source of greenhouse gas emissions today  quality and carbon savings increase  and a strategic material for the clean  every time it passes through the  energy sector of tomorrow, the stakes  recycling loop.”  are high, and our responsibility is clear.  a desire for policymakers to accelerate “Unlike most other  the shift towards cleaner energy while  packaging materials,  balancing that with affordability.  aluminium is  Recycling initiatives can also go a  infinitely recyclable”  Tom Giddings Executive Director, Alupro  long way to boosting net-zero targets. The report adds that recycling is a big lever that can be pulled to reduce carbon emissions. It believes that increasing the proportion of recycled"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 20-arrow-1\" style=\"top: -71px;left: 433px;\" src=\"/issue1/static/_content/20-arrow-1.png\" />\n        <img class=\"abs halfScale 20-text-1\" style=\"top: 182px;left: 447px;\" src=\"/issue1/static/_content/20-text-1.png\" />\n        <h1 id=\"20-no\" class=\"abs sommet-rounded 20-no\" style=\"top:262px; left:471px; font-size:3.4em; font-weight:300; color:#9ed146; margin:0px;\" data-number='{\"to\": 30}' ></h1>\n        <img class=\"abs halfScale 20-text-2\" style=\"top: 288px;left: 449px;\" src=\"/issue1/static/_content/20-text-2.png\" />\n        <h1 id=\"20-no\" class=\"abs sommet-rounded 20-no\" style=\"top:382px; left:446px; font-size:3.4em; font-weight:300; color:#9ed146; margin:0px;\" data-number='{\"to\": 92.4, \"decimals\":\"1\"}' ></h1>\n        <img class=\"abs halfScale 20-text-3\" style=\"top: 408px;left: 449px;\" src=\"/issue1/static/_content/20-text-3.png\" />\n\n\n\n        ",
    "script": "\n          function onPageEnter() {\n            pg20Anim = new TimelineMax();\n            pg20Anim.fromTo(cOf(\"20-arrow-1\"), 0.3, {y:-70,opacity:0}, {y:0, opacity:1, ease: Power2.easeNone}, 1)\n            .fromTo(cOf(\"20-text-1\"), 0.3, {y:20,opacity:0}, {y:0, opacity:1, ease: Power2.easeNone}, 1.3)\n            .fromTo(cOf(\"20-no\")[0], 0.3, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[0]);}}, 1.3)\n            .fromTo(cOf(\"20-text-2\"), 0.3, {y:20,opacity:0}, {y:0, opacity:1, ease: Power2.easeNone}, 1.4)\n            .fromTo(cOf(\"20-no\")[1], 0.3, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[1]);}}, 1.4)\n            .fromTo(cOf(\"20-text-3\"), 0.3, {scale:0}, {scale:0.5, ease: Power2.easeOut}, 1.5)\n\n          }\n\n          function onPageLeave() {\n            pg20Anim.stop()\n            removeContentLinks()\n            resetNumbers(\"20-no\")\n          }\n      ",
    "searchText": "the loop aluminium can result in a “significantly  important priorities are maximising  are already implementing ambitious  lower greenhouse gas footprint than  the volume of aluminium collected for  carbon reduction roadmaps.  primary aluminium production”.  recycling, maintaining a high recycling rate  It expands that “aluminium recycling only needs 5% of the energy needed to produce the primary metal” and this “represents an important decarbonisation path which should be adequately ustry Ind  supported and incentivised”. The report cautions that “primary aluminium production will remain important in the future, as secondary aluminium alone will  Section 3  not be sufficient to meet future demand, even if scrap aluminium collection rates are substantially increased”.  Keeping up with demand Consumption is rising and aluminium is feeling the pressure. In November 2023, the EU reached a provisional agreement on a European critical raw materials act. Aluminium is on the critical list. A report published by the International Aluminium Institute revealed that global aluminium demand is expected to increase by almost 40% by 2030 and that the sector will need to produce an additional 33.3 million tonnes in total to meet demand growth in all sectors. Alupro’s Giddings adds: “Coping with increased demand will involve  20 23  a combination of strategic approaches, technological advancements and sustainable practices. The most  2050  deadline to hit net zero  30%  projected increase in aluminium demand by 2030  92.4% reduction in industry GHG emissions targeted by 2050  and ensuring a majority of the material  Several beverage can manufacturers have  is kept within Europe. This will not only  set out their route to carbon reduction  help to meet demand, but also accelerate  through changes to the manufacturing  progress towards a more circular economy  process. One such company is committed  for aluminium – all while minimising  to a 55% reduction in carbon by 2030.  carbon emissions.”  It believes this is achievable through using 75% renewable energy by 2025 and  Canmakers taking action  100% by 2030. The same company also  Although the biggest scope for  signalled its intention to go against trends  decarbonisation impact comes from  that increase the size, shape or label of  aluminium producers, canmakers have  a can, as it’s these fine margins that can  a significant role to play too – and many  add up to big gains. There are signs that"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "the loop the strategy is working as it strives to  Amongst its wide range of activities, the  transitioned to solar energy at its  reduce the energy consumption of its  company has targeted small savings in a  site in the Netherlands. Reduced  machines. In 2020, its sites in Italy and  bid to make a big difference. For example,  electricity usage and the introduction  Germany reported a saving of 4,000  it controls coating weight and reduces the  of a new cooling system (saving  megawatt hours of electricity thanks  number of coating pass applications. In  401 megawatts of electricity) has  to air compressor replacements.  addition, it is shifting towards the use  also helped lessen its environmental  of more water-based coatings.  impact at its German facility.  committed to the Science Based Targets  A third beverage can manufacturer has  initiative (SBTi) and it’s not the only one.  linked its strategy to the UN’s sustainable  Beverage brands reducing their impact  recycling only  Another beverage canmaker has used the  development goals. It is also working  It’s not just the manufacturers and  needs 5% of the  initiative to measure its carbon reductions.  to approved SBTi targets and has  canmakers making strides in this  energy needed  Section 3  ustry Ind  The manufacturer we spoke to is  area – beverage brands themselves  to produce the  are stepping up too. One global  primary metal”  beverage specialist has also signed up to SBTi and its European bottling and distribution arm has already hit 74% renewable electricity use. Hundreds of millions of euros have been committed to this strategy, with a carbon reduction roadmap in place. The drive also aims to boost recycling. Ultimately, unpicking these issues will require collaboration and joined-up thinking in the beverage can market. It’s encouraging to see the supply chain take the initiative and look at how innovative technology can make a difference. That 2050 net-zero target is daunting, but there is enough momentum across the industry to hit that goal.  21 23  “Aluminium  Net-zero by 2050 Science-based Decarbonisation Pathways for the European Aluminium Industry"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:738px;left:158px;width:149px;height:59px\">\n          <a href=\"https://canmakersbenelux.com/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:738px;left:348px;width:149px;height:59px\">\n          <a href=\"https://laboiteboisson.com\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:738px;left:527px;width:149px;height:59px\">\n          <a href=\"https://forum-getraenkedose.de\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:738px;left:715px;width:149px;height:59px\">\n          <a href=\"https://latasdebebidas.org\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:738px;left:893px;width:149px;height:59px\">\n          <a href=\"https://www.canmakers.co.uk\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "the loop  ABOUT METAL PACKAGING EUROPE This triannual magazine is published by Metal Packaging Europe, a trade body that represents the rigid metal packaging industry across the continent. We represent 13 corporate members and 10 associate members. MPE serves as the unified voice of the rigid metal packaging industry in conversations with policymakers and other stakeholders. It strives  About Us  to facilitate knowledge-sharing to enhance agility and competitiveness, and to support companies on the key challenges facing our industry. Our ultimate goal is to make metal the preferred choice for consumer and industrial packaging by raising awareness of its infinite versatility and importance in building a truly circular economy.  THE BEVERAGE EXECUTIVE COMMITTEE AND BEVERAGE CAN ASSOCIATIONS Within Metal Packaging Europe, the Beverage Executive Commission proactively supports the positive perception of beverage cans as a sustainable, circular packaging solution. Its members – Ardagh, Ball, CANPACK and Crown – collaborate to drive aluminium beverage can circularity throughout the supply chain and industry as a whole, and are represented at national level in the Benelux countries, France, Germany, Spain and the UK by the following Beverage Can Associations.  22 23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:766px;left:351px;width:60px;height:59px\">\n          <a href=\"https://metalpackagingeurope.org/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:766px;left:450px;width:60px;height:59px\">\n          <a href=\"https://twitter.com/metal_packaging?s=20\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:756px;left:553px;width:130px;height:77px\">\n          <a href=\"https://metalpackagingeurope.org/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:766px;left:718px;width:60px;height:59px\">\n          <a href=\"https://www.instagram.com/metal_packaging_eu/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:766px;left:814px;width:60px;height:59px\">\n          <a href=\"https://www.linkedin.com/company/metal-packaging-europe/\" target=\"_blank\"></a>\n        </div>\n\n        <div id=\"subscribe-overlay\" class=\"standardTransition contentOverlay hidden noclick\">\n          <div id=\"mc_embed_shell\">\n            <link href=\"//cdn-images.mailchimp.com/embedcode/classic-061523.css\" rel=\"stylesheet\" type=\"text/css\">\n            <div id=\"mc_embed_signup\">\n              <img id=\"subscription-cross\" onclick=\"hideOverlay('subscribe-overlay')\" src=\"/issue1/static/_content/subscription-cross.png\" />\n              <form action=\"https://kpstudio.us22.list-manage.com/subscribe/post-json?u=1db79021f22160aa6c8eff4de&amp;id=41edb2fc75&amp;f_id=0030c1e1f0&c=?\" method=\"post\" id=\"mc-embedded-subscribe-form\" name=\"mc-embedded-subscribe-form\" class=\"validate\" target=\"_blank\">\n                <div id=\"mc_embed_signup_scroll\">\n                  <img id=\"subscription-img\" src=\"/issue1/static/_content/subscription-img.png\" />\n                  <h2 class=\"sommet-rounded\">Stay in the loop!</h2>\n                  <div class=\"mc-field-group\">\n                    <label class=\"open-sans-regular\" for=\"mce-EMAIL\">\n                      Enter your email below to receive future issues of <strong class=\"open-sans-bold\">The Loop</strong> direct to your inbox\n                    </label>\n                    <input type=\"email\" name=\"EMAIL\" class=\"required email open-sans-regular\" id=\"mce-EMAIL\" required=\"\" value=\"\" placeholder=\"johnsmith@email.com\">\n                  </div>\n                  <div id=\"mce-responses\" class=\"clear\">\n                    <div class=\"response open-sans-regular\" id=\"mce-error-response\" style=\"display: none;\"></div>\n                    <div class=\"response open-sans-regular\" id=\"mce-success-response\" style=\"display: none;\">There has been an error, please try again.</div>\n                  </div>\n                  <div aria-hidden=\"true\" style=\"position: absolute; left: -5000px;\"><input type=\"text\" name=\"b_1db79021f22160aa6c8eff4de_41edb2fc75\" tabindex=\"-1\" value=\"\"></div>\n                  <div class=\"clear\"><input type=\"submit\" name=\"subscribe\" id=\"mc-embedded-subscribe\" class=\"button sommet-rounded\" value=\"Subscribe\" onclick=\"mailChimpSubmit()\"></div>\n                </div>\n              </form>\n            </div>\n            <script type=\"text/javascript\" src=\"//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js\"></script>\n            <script type=\"text/javascript\">(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';fnames[5]='BIRTHDAY';ftypes[5]='birthday';}(jQuery));var $mcj = jQuery.noConflict(true);</script>\n          </div>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n            showOverlay('subscribe-overlay');\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n          hideOverlay('subscribe-overlay');\n        }\n      ",
    "searchText": "the loop"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function mailChimpSubmit(){\n        $('#mc-embedded-subscribe-form').submit(function (e) {\n          var that = $(this);\n          console.log('HELLO')\n          var mailchimpSubmit = $(this).find('input[type=submit]');\n          var errorResponse = $('#mce-error-response');\n          var successResponse = $('#mce-success-response');\n\n          e.preventDefault();\n\n          $.ajax({\n            method: 'GET',\n            url: that.attr('action'),\n            data: that.serialize(),\n            dataType: 'jsonp',\n            success: function(data) {\n              console.log('AJAX SUCCESS')\n            // If there was an error then show the error message.\n            if (data.result === 'error') {\n              console.log('AJAX ERROR')\n              // If the error has an error code at front then alter the message to not include the error code and hyphen.\n              if(data.msg.indexOf('0') === 0) {\n                data.msg = data.msg.slice(3);\n              }\n              errorResponse.html(data.msg).fadeIn(300).delay(3000).fadeOut(300);\n            }\n            // If success then show message\n            else {\n              successResponse.html('Thank you for subscribing!').fadeIn(300).delay(3000).fadeOut(300);\n              setTimeout(function(){\n                hideOverlay('subscribe-overlay');\n              },3500)\n\n            }\n            }\n          });\n        });\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 60;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-ZVDYH3VWEJ" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "URg0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d/CA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gck0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gqD2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "icNF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lGnO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "loeG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mLy2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n9S7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oEyU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tATK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tki5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y5zj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yREt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ye3r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6f2d99334794a67712ef.js